import React from 'react';
import { FaChevronDown } from 'react-icons/fa6';

import { FormControl, MenuItem, Select } from '@mui/material';

export interface SelectedProps {
  label: string;
  value: string;
}

type DropdownProps = {
  testId?: string;
  selected: SelectedProps;
  options: SelectedProps[];
  onChange: (value: SelectedProps) => void;
};

const Dropdown: React.FC<DropdownProps> = ({ selected, options, onChange }) => (
  <FormControl fullWidth>
    <Select
      labelId='dropdown-label'
      value={selected.value}
      onChange={e => {
        const selectedOption = options.find(option => option.value === e.target.value);
        if (selectedOption) {
          onChange(selectedOption);
        }
      }}
      sx={{
        width: { xs: '110px', md: '170px' },
        alignSelf: 'end',
        border: '1px solid black',
        borderRadius: '16px',
        backgroundColor: 'grey.100',
        fontSize: { xs: 12, md: 16 },
        padding: 0,
        '.MuiSelect-icon': {
          marginRight: { xs: '4px', md: '8px' },
        },
      }}
      inputProps={{
        sx: {
          px: { xs: 1, md: 2 },
          py: 1,
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            borderRadius: '8px',
            mt: 1,
          },
        },
        MenuListProps: {
          sx: {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      }}
      IconComponent={FaChevronDown}
    >
      {options.map((option, index) => (
        <MenuItem
          sx={{
            fontSize: { xs: 12, md: 16 },
            p: 1.5,
          }}
          key={index}
          value={option.value}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default Dropdown;
